import { Button, PageHeader } from 'components';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Divider, Row, Table } from 'antd';
import { Link, Route, Routes, useNavigate } from 'react-router-dom';
import { PlusOutlined } from '@ant-design/icons';
import { useRecoilValue } from 'recoil';
import { getPage } from '../../../../../hooks/useUser';
import { useLeasingPlans } from '../useLeasingPlans';
import styles from '../../contactRoles/main/style.module.scss';
import Filters from '../../../../../components/filters';
import DeleteModal from '../../../../../components/deleteModalView';

const MainPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const pages = useRecoilValue(getPage);
  const {
    data,
    filters,
    columns,
    loading,
    onChangeTableFilter,
    updateInProcess,
    onDelete,
  } = useLeasingPlans();

  const handleOnRow = useCallback(
    (record) => ({
      onClick: () => {
        navigate(`${record.id}`);
      },
    }),
    [navigate],
  );

  return (
    <>
      <PageHeader title={t('LEASING PLANS').toUpperCase()}>
        <Row>
          {pages?.ability?.can_create && (
            <Col>
              <Link to={'new'}>
                <Button width={'138px'} big icon={<PlusOutlined />}>
                  {t('NUOVO')}
                </Button>
              </Link>
            </Col>
          )}
        </Row>
      </PageHeader>
      <div className={styles.container}>
        <Filters filters={filters} />
        <Divider />
        <Table
          columns={columns}
          dataSource={data.plans}
          pagination={data.pagination}
          loading={loading}
          onChange={onChangeTableFilter}
          scroll={{ x: 600 }}
          onRow={handleOnRow}
        />
      </div>
      <Routes>
        <Route
          path={':id/delete'}
          element={
            <DeleteModal loading={updateInProcess} onClickDelete={onDelete} />
          }
        />
      </Routes>
    </>
  );
};

export default MainPage;
